'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FullDescription = require('./FullDescription');

Object.defineProperty(exports, 'FullDescription', {
  enumerable: true,
  get: function get() {
    return _FullDescription.FullDescription;
  }
});

var _ShortDescription = require('./ShortDescription');

Object.defineProperty(exports, 'ShortDescription', {
  enumerable: true,
  get: function get() {
    return _ShortDescription.ShortDescription;
  }
});

var _Slider = require('./Slider');

Object.defineProperty(exports, 'Slider', {
  enumerable: true,
  get: function get() {
    return _Slider.Slider;
  }
});

var _Stars = require('./Stars');

Object.defineProperty(exports, 'Stars', {
  enumerable: true,
  get: function get() {
    return _Stars.Stars;
  }
});

var _Breads = require('./Breads');

Object.defineProperty(exports, 'Breads', {
  enumerable: true,
  get: function get() {
    return _Breads.Breads;
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/index.js
// module id = 749
// module chunks = 0